// Mock data for Vejles Juletræsfest

export const eventInfo = {
  title: "Vejles Juletræsfest",
  subtitle: "For børn i udsatte familier",
  date: "14. december 2026",
  location: "Bygningen Vejle",
  address: "Ved Anlæget 14B, 7100 Vejle",
  year: 6, // 6. gang
  childrenHelped: 150,
  email: "info@juletræsfestvejle.dk"
};

export const teamMembers = [
  {
    id: 1,
    name: "Kasper Højsgaard",
    role: "Medstifter & Arrangør",
    description: "En af de tre frivillige ildsjæle bag Vejles Juletræsfest."
  },
  {
    id: 2,
    name: "Michael Pedersen",
    role: "Medstifter & Arrangør",
    description: "Knokler hvert år for at skabe en magisk dag for børnene."
  },
  {
    id: 3,
    name: "Lennarth Højgaard",
    role: "Medstifter & Arrangør",
    description: "Dedikeret til at give udsatte børn uforglemmelige oplevelser."
  },
  {
    id: 4,
    name: "Katrine Depka",
    role: "Arrangør",
    description: "Hjælper med at koordinere festen og sikre den bedste oplevelse."
  },
  {
    id: 5,
    name: "Morten Kjærholt",
    role: "Arrangør",
    description: "En vigtig del af holdet bag den årlige juletræsfest."
  }
];

export const aboutInfo = {
  mission: "At give børn fra socialt udsatte og økonomisk trængte familier i Vejle Kommune en magisk juleaften, de aldrig glemmer.",
  history: `Vejles Juletræsfest startede i 2018 som et initiativ af tre venner, der ønskede at gøre en forskel. Siden da er festen vokset år for år, og nu hjælper vi over 100 børn hvert år.\n\nFesten afholdes i samarbejde med BROEN Vejle, som står for at finde og udvælge familierne. Hvert barn modtager personligt udvalgte gaver baseret på deres egne ønsker.\n\nDet er hårdt arbejde at arrangere festen, men opbakningen fra lokale virksomheder og privatpersoner gør det hele muligt.`,
  partnership: "I samarbejde med BROEN Vejle"
};

export const sponsors = [
  { id: 1, name: "Porsche Servicecenter Vejle" },
  { id: 2, name: "Jelling Musikfestival" },
  { id: 3, name: "Stock Group" },
  { id: 4, name: "Middelfart Sparekasse Vejle" },
  { id: 5, name: "Stormes Grafisk" },
  { id: 6, name: "Egil Rasmussen Vejle A/S" },
  { id: 7, name: "Kaffebaren Vejle" },
  { id: 8, name: "All Creative A/S" },
  { id: 9, name: "Bygningen Vejle" },
  { id: 10, name: "Carlsberg" },
  { id: 11, name: "Royal Unibrew" },
  { id: 12, name: "Restaurant Flammen Vejle" }
];

export const festProgram = [
  {
    time: "14:00",
    title: "Dørene åbner",
    description: "Velkommen til Bygningen Vejle - garderobe og velkomstdrink til forældre."
  },
  {
    time: "14:30",
    title: "Aktiviteter & Leg",
    description: "Sjove aktiviteter, ansigtsmaling og juleværksted for børnene."
  },
  {
    time: "15:30",
    title: "Julemiddag",
    description: "Lækker julemad leveret af Restaurant Flammen."
  },
  {
    time: "16:30",
    title: "Julemanden kommer!",
    description: "Den store mand med det hvide skæg ankommer med gaver til alle børn."
  },
  {
    time: "17:30",
    title: "Dans om juletræet",
    description: "Vi synger julesange og danser om det store juletræ."
  },
  {
    time: "18:00",
    title: "Farvel og glædelig jul",
    description: "Vi siger farvel og ønsker alle en rigtig glædelig jul!"
  }
];

export const stats = [
  { number: "5", label: "Års traditioner" },
  { number: "500+", label: "Børn hjulpet" },
  { number: "50+", label: "Frivillige" },
  { number: "100%", label: "Kærlighed" }
];
